import axios from "axios";

export default {
  getOrders() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/orders`,
    });
  },
  getOrder(_id) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/orders/${_id}`,
    });
  },
  createOrder(order) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_URI}/orders`,
      data: {
        ...order,
        orderId: order.orderId,
      },
    });
  },
  updateOrder(order) {
    return axios({
      method: "patch",
      url: `${process.env.VUE_APP_API_URI}/orders/${order._id}`,
      data: {
        ...order,
        orderId: order.orderId,
      },
    });
  },
};
